import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-4 py-4.5 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500 mb-4"
}

import { computed, onUnmounted, ref, watch } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import { useOriginStore } from "@/stores/origin"
import { debounce, getNotFoundText } from "@/shared/utils/helpers"
import { SearchIcon } from "@heroicons/vue/outline"

interface Props {
    originsSelectedState: boolean[]
    hasFilterOrigins: boolean
    typeName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterOrigin',
  props: {
    originsSelectedState: {},
    hasFilterOrigins: { type: Boolean },
    typeName: {}
  },
  emits: ["onOriginSelect"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const originStore = useOriginStore()

const localOriginsSelectedState = ref<boolean[]>(props.originsSelectedState)

const origins = computed(() => originStore.tableState.data)
const notHiddenOrigins = computed(() => originStore.tableState.data.filter((origin) => !origin.isHidden))

function createFilterOrigin() {
    // get the selected origins ids which are selected in localOriginsSelectedState
    const selectedOriginsIds = localOriginsSelectedState.value
        .map((selected, index) => (selected ? origins.value[index]._id : null))
        .filter((id) => id !== null)

    emit("onOriginSelect", selectedOriginsIds)
}

onUnmounted(() => {
    originStore.tableState.search = ""
})

watch(
    () => originStore.tableState.search,
    debounce(() => {
        if (props.hasFilterOrigins) {
            // this is to prevent the search from being triggered when the modal is closed
            return
        }
        originStore.tableState.currentPage = 0
        originStore.getOrigins()
    }, 250)
)

watch(
    () => localOriginsSelectedState.value,
    () => {
        createFilterOrigin()
    },
    { deep: true }
)

watch(
    () => props.originsSelectedState,
    () => {
        localOriginsSelectedState.value = props.originsSelectedState
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsInput, {
      modelValue: _unref(originStore).tableState.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(originStore).tableState.search) = $event)),
      placeholder: "Search values",
      iconStart: _unref(SearchIcon)
    }, null, 8, ["modelValue", "iconStart"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(originStore).tableState.isLoading)
        ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notHiddenOrigins.value, (origin, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: origin._id,
                class: "flex items-center mb-5 last:mb-0"
              }, [
                _createVNode(GgmsCheckBox, {
                  modelValue: localOriginsSelectedState.value[i],
                  "onUpdate:modelValue": ($event: any) => ((localOriginsSelectedState.value[i]) = $event),
                  indeterminate: _ctx.originsSelectedState[i] === null
                }, {
                  default: _withCtx(() => [
                    _createVNode(GgmsChip, {
                      bgColor: origin.backgroundColor,
                      textColor: origin.foregroundColor,
                      isRemovable: false,
                      class: "ml-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(origin.displayName), 1)
                      ]),
                      _: 2
                    }, 1032, ["bgColor", "textColor"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "indeterminate"])
              ]))
            }), 128)),
            (!notHiddenOrigins.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(getNotFoundText)("origins", _unref(originStore).tableState.search)), 1))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 64))
}
}

})